import { isValid } from 'date-fns';
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
	Button,
	Form,
	Modal,
	Table
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { withTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FiDelete } from 'react-icons/fi';
import { toast } from "react-toastify";
import { LoaderContext, RegulationContext } from "../../../../App";
import ReportingPeriod from "../../../../components/Regulation/ReportingPeriod";
import { DataViewCategoryType, StandardCategory, USER_ROLE } from "../../../../core/constants/common";
import CompanyService from "../../../../core/service/CompanyService";
import DataCollectionEventService from '../../../../core/service/DataCollectionEventService';
import StandardService from "../../../../core/service/StandardService";
import UserService from '../../../../core/service/UserService';
import Utils from "../../../../core/utilities/Utils";
import "../Forms.scss";

const CardType = {

	FORM_DETAILS: 2,
	PERMISSION: 3,
	PERMISSION_CONFIGURATION: 4,
	CONFIRMATION: 5
};

function QualitativeDCEModal({ t, duplicate, onHide, onSave, enablePermCard, id }) {

	const { glbRegulation } = useContext(RegulationContext);
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [show, setShow] = useState(true);
	const [topics, setTopics] = useState([]);
	const [selectedTopic, setSelectedTopic] = useState(null);
	const [questions, setQuestions] = useState({});
	const [activeCard, setActiveCard] = useState((enablePermCard) ? CardType.PERMISSION_CONFIGURATION : CardType.FORM_DETAILS);
	const [users, setUsers] = useState([])
	const [dataToSave, setDataToSave] = useState({
		period: `${new Date().getFullYear()}-${Utils.getMonthFromFrequency(glbRegulation.frequency)}-01`,
		lastSubmissionDate: null,
		permissions: [],
		regulationId: glbRegulation.id
	});
	const [detailsValidated, setDetailsValidated] = useState(false);
	const [permsValidated, setPermsValidated] = useState(false);
	const [selectedQuestion, setSelectedQuestion] = useState(null)
	const [topicVisibility, setTopicVisibility] = useState({});
	const [permBubble, setPermBubble] = useState(false)
	useEffect(() => {
		listUsers();
		fetchAllQualitativeTopics();
	}, []);


	const listUsers = (pageSize = 10, pageNumber = 0) => {
		UserService.getUsers(pageNumber, pageSize, '', '', true,
			[USER_ROLE.SUBSCRIBER_TEAM_MEMBER, USER_ROLE.SUBSCRIBER_RISK_ASSESSOR]
		).then((response) => {
			const totalCount = parseInt(response.headers["x-total-count"], 10);
			setUsers(response.data);
		})
			.catch((error) => {
			});
	};
	const hasPermissionForQuestion = (topicId) => {
		const index = dataToSave?.permissions?.findIndex(p => p.topic?.id === topicId);
		if (index < 0) return false;

		return dataToSave?.permissions[index]?.users?.length > 0;
	};
	const hasPermissionForQuestions = (QId) => {
		const index = dataToSave?.permissions?.findIndex(p => p.question?.id === QId);
		if (index < 0) return false;

		return dataToSave?.permissions[index]?.users?.length > 0;
	};
	const onPermissionDelete = (topicId) => {

		const perms = JSON.parse(JSON.stringify(dataToSave.permissions));
		const permIndex = perms.findIndex(p => p.topic?.id === topicId);
		if (permIndex < 0 || !perms[permIndex]) return;

		perms.splice(permIndex, 1);
		setDataToSave({
			...dataToSave,
			permissions: perms
		});
	};
	const onPermissionDeleteQn = (QId) => {
		const perms = JSON.parse(JSON.stringify(dataToSave.permissions));
		const permIndex = perms.findIndex(p => p.question?.id === QId);
		if (permIndex < 0 || !perms[permIndex]) return;

		perms.splice(permIndex, 1);
		setDataToSave({
			...dataToSave,
			permissions: perms
		});
	};
	const fetchAllQualitativeTopics = () => {
		StandardService.getTopicsByStandard(glbRegulation.id, false, StandardCategory.QUALITATIVE)
			.then((response) => {
				if (response.status !== 200) return;

				setTopics(response.data ?? []);
			})
			.catch((error) => {
			});
	}

	useEffect(() => {
		getDCEData(id)
	}, [id]);

	const getDCEData = (id) => {
		if (!id) return;

		DataCollectionEventService.getDCE(id)
			.then((response) => {

				const perms = [];
				response.data.permissions.forEach(p => {
					const perm = {
						id: p.id,
						topic: p.topic ? { id: p.topic.id, name: p.topic.name } : null,
						question: p.question ? { id: p.question.id, text: p.question.text } : null,
						users: []
					};
					p.users.forEach(u => {
						perm.users.push({
							id: u.id,
							login: u.login,
							name: u.name,
							email: u.email
						});
					});
					perms.push(perm);
				});
				setDataToSave({
					period: response.data.period,
					lastSubmissionDate: response.data.lastSubmissionDate,
					permissions: perms,
					regulationId: glbRegulation.id
				});
			})
			.catch((error) => {

			});
	}

	const toggleTopicVisibility = (topicId) => {
		setTopicVisibility(prevVisibility => ({
			...prevVisibility,
			[topicId]: !prevVisibility[topicId]
		}));
	};

	const saveQualitativeDCE = () => {
		let req;
		if (!duplicate && id > 0) {
			req = DataCollectionEventService.updateDCE(id, dataToSave);
		} else {
			req = DataCollectionEventService.createDCE(dataToSave);
		}

		setLoaderDisplay(true);
		req.then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			const successMessage = !duplicate && id > 0 ? "Success" : t('AssessmentCreationSuccessMessage.label');
			toast.success(successMessage, {
				position: toast.POSITION.TOP_RIGHT,
			});

			exitModal();
			onSave();
		}).catch(err => {
			setLoaderDisplay(false);
		});
	}

	const getQuestions = (topic) => {
		if (!topic.id) return;


		CompanyService.getMetricQuestions(glbRegulation.id, dataToSave.period, DataViewCategoryType[topic.categoryType], topic.id)
			.then(res => {

				if (res.data) {
					setQuestions(prevQuestions => ({
						...prevQuestions,
						[topic.id]: res.data
					}));
				} else {
					setQuestions(prevQuestions => ({
						...prevQuestions,
						[topic.id]: []
					}));
				}
			})
			.catch(error => {

			});
	};

	const renderTopics = () => {
		return topics.map((topic) => (
			<React.Fragment key={`topic-${topic.id}`}>
				<tr style={{ cursor: 'pointer' }}
					onClick={() => {
						setSelectedTopic(topic);
						setSelectedQuestion(null);
						getQuestions(topic);
					}}
					className={selectedTopic?.id === topic.id ? 'bg-selected-row' : ''}>
					<td className='cursor' onClick={() => setSelectedTopic(topic)}>
						<div className='Section_Sub-section_dropdown'>
							{topicVisibility[topic.id] ? <span className='dropdown_icon'><FaChevronUp className="mx-1" onClick={() => toggleTopicVisibility(topic.id)} /></span> : <span className='dropdown_icon'><FaChevronDown className="mx-1 " onClick={() => toggleTopicVisibility(topic.id)} /></span>} {topic.name}
						</div>
					</td>
					<td>{renderSelectedUserForTopic(topic.id)}</td>
					<td>
						{
							hasPermissionForQuestion(topic.id) &&
							<span className="cursor mx-1">
								<FiDelete onClick={() => onPermissionDelete(topic.id)} />
							</span>
						}
					</td>
				</tr>
				{topicVisibility[topic.id] &&
					<>
						{
							questions[topic.id]?.map(question => {
								return (
									<tr className={selectedQuestion?.id === question.id ? 'bg-selected-row' : ''}>
										<td>
											<div className='Section_Sub-section_dropdown cursor' key={`question-${question.id}`} onClick={() => {
												setSelectedQuestion({ id: question.id, title: question.question });
												setSelectedTopic(null)
											}}>
												{question.question}
											</div>

										</td>
										<td>{renderSelectedUserForQuestion(question?.id)}</td>
										<td>
											{
												hasPermissionForQuestions(question?.id) &&
												<span className="cursor mx-1">
													<FiDelete onClick={() => onPermissionDeleteQn(question?.id)} />
												</span>
											}
										</td>

									</tr>
								)
							})
						}
					</>
				}
			</React.Fragment>
		));
	};

	const exitModal = () => {
		setShow(false);
		onHide();
	};

	const onBack = () => {
		const prevCard = activeCard - 1;
		if (activeCard === CardType.PERMISSION_CONFIGURATION) {
			setActiveCard(CardType.FORM_DETAILS);
		}
		if (activeCard === CardType.CONFIRMATION) {
			setActiveCard(CardType.PERMISSION_CONFIGURATION);
		}
	};

	const onNext = () => {
		if (activeCard === CardType.FORM_DETAILS
			&& (!dataToSave.lastSubmissionDate || !dataToSave.period)) {
			setDetailsValidated(true);
			return
		}
		if (activeCard === CardType.PERMISSION
			&& dataToSave.supplierIds?.length === 0) {
			setPermsValidated(true);
			return;
		}
		if (activeCard === CardType.PERMISSION_CONFIGURATION
			&& dataToSave.permissions?.length === 0) {
			setPermsValidated(true);
			return;
		}
		// expiryDate validation
		const currentDate = new Date();
		const lastSubmissionDate = new Date(dataToSave.lastSubmissionDate);

		if (lastSubmissionDate <= currentDate) {
			toast.error("Expiry date should be in the future.", {
				position: toast.POSITION.TOP_RIGHT,
				autoClose: false,
			});
			return;
		}
		setPermsValidated(false);

		const nextCard = activeCard + 1;

		if (activeCard === CardType.FORM_DETAILS) {
			setActiveCard(CardType.PERMISSION_CONFIGURATION);
		} else {
			setActiveCard(nextCard > CardType.CONFIRMATION ? CardType.CONFIRMATION : nextCard);
		}
	}
		;

	const setLastSubmissionDate = (date) => {
		setDataToSave({
			...dataToSave,
			lastSubmissionDate: moment(date).format('YYYY-MM-DD')
		});
	};
	const onUserCheck = (id, username) => {
		const perms = JSON.parse(JSON.stringify(dataToSave.permissions));

		if (selectedTopic?.id > 0) {
			const permIndex = perms.findIndex(p => p.topic?.id === selectedTopic.id);
			if (permIndex >= 0) {
				const userIndex = perms[permIndex].users.findIndex(u => u.id === id);
				if (userIndex >= 0) {
					perms[permIndex].users.splice(userIndex, 1);
					// Remove the permission object if there are no users left
					if (perms[permIndex].users.length === 0) {
						perms.splice(permIndex, 1);
					}
				} else {
					perms[permIndex].users.push({ id: id, name: username });
				}
			} else {
				perms.push({
					topic: { id: selectedTopic.id, name: selectedTopic.name },
					users: [{ id: id, name: username }]
				});
			}
		} else if (selectedQuestion?.id > 0) {
			const permIndex = perms.findIndex(p => p.question?.id === selectedQuestion?.id);
			if (permIndex >= 0) {
				const userIndex = perms[permIndex].users.findIndex(u => u.id === id);
				if (userIndex >= 0) {
					perms[permIndex].users.splice(userIndex, 1);
					// Remove the permission object if there are no users left
					if (perms[permIndex].users.length === 0) {
						perms.splice(permIndex, 1);
					}
				} else {
					perms[permIndex].users.push({ id: id, name: username });
				}
			} else {
				perms.push({
					question: { id: selectedQuestion?.id, name: selectedQuestion.title },
					users: [{ id: id, name: username }]
				});
			}
		}
		setDataToSave({
			...dataToSave,
			permissions: perms
		});
	}

	const isPermittedForUser = (userId) => {
		if (selectedTopic?.id > 0) {
			const index = dataToSave.permissions?.findIndex(p => p.topic?.id === selectedTopic.id);
			if (index < 0) return false;
			return dataToSave.permissions[index].users?.findIndex(u => u.id === userId) >= 0;
		}
		else if (selectedQuestion?.id > 0) {
			const index = dataToSave.permissions?.findIndex(p => p.question?.id === selectedQuestion?.id);
			if (index < 0) return false;
			return dataToSave.permissions[index].users?.findIndex(u => u.id === userId) >= 0;
		}

	}
	const renderFooterActions = () => {
		return (
			<div className="text-center p-3 pt-2">

				{(!enablePermCard) && (
					<>
						{activeCard !== CardType.FORM_DETAILS
							&&
							<Button
								variant="secondary"
								className="px-4 me-2"
								onClick={() => onBack()}
							>
								{t("Back.label")}
							</Button>
						}


						<Button
							variant="secondary"
							className="px-4 me-2"
							onClick={() => exitModal()}
						>
							{t("Cancel.label")}
						</Button>
						<Button
							variant="primary"
							className="px-4"
							onClick={() => onNext()}
						>
							{t("Next.label")}
						</Button>
					</>
				)}

				{(enablePermCard) && (
					<Button variant="primary "
						className="px-4"
						onClick={() => saveQualitativeDCE()}
					>
						{t("Save.label")}
					</Button>
				)}
			</div>
		);
	};

	const detailsCardToRender = () => {
		return (
			<div className={activeCard === CardType.FORM_DETAILS ? '' : 'd-none'}>
				<div>
					<h4>{t('FormDetailsQualitativeCard.label')}</h4>

				</div>
				<div className="assessmentCard_form">
					<div className="row m-0 justify-content-center FormDetailsCard_002">
						<div className="col-md-6 p-2 text-start 5">
							<Form className="pb-5" noValidate validated={detailsValidated}>
								<div className="row m-0 mb-3">
									<div className="col-md-12 p-2">
										<label>{t('ReportingPeriod.label')}</label>

										<ReportingPeriod
											disabled={!duplicate && id > 0}
											defaultFrequency='ANNUAL'
											defaultPeriod={id > 0 ? dataToSave.period : null}
											defaultRegulation={dataToSave.regulation}
											valueChangeCallback={(period) =>
												setDataToSave({ ...dataToSave, period: `${period.year}-${period.month}-01` })
											} />
									</div>
								</div>
								<div className="row m-0 mb-3">
									<div className="col-md-12 p-2">
										<label>{t('Expiry.label')}</label>

										<div className="pb-2">
											<DatePicker
												selected={
													dataToSave.lastSubmissionDate && isValid(new Date(dataToSave.lastSubmissionDate))
														? new Date(dataToSave.lastSubmissionDate)
														: null
												}
												onChange={(date) => setLastSubmissionDate(date)}
												className="form-control"
												required
												dateFormat="dd/MM/yyyy"
												minDate={new Date()}
											/>
										</div>

									</div>
								</div>
							</Form>
							{renderFooterActions()}
						</div>
					</div>
				</div>
			</div>
		);
	};

	const permissionConfigurationCardToRender = () => {
		return (
			<div className={activeCard === CardType.PERMISSION_CONFIGURATION ? '' : 'd-none'}>
				<div>
					{enablePermCard ? (
						<h4>{t('PermissionConfigHeaders.label')}</h4>
					) : (
						<h4>{t('PermissionConfigHeader.label')}</h4>
					)}
					<p>{t('PermissionConfigText.label')}</p>
				</div>
				<div className="assessmentCard_form">
					<div className="row m-0">
						<div className="col-md-7 p-2 text-start ConfigurePermissionsTable">
							{
								permsValidated &&
								<div className="alert alert-danger m-0 p-1">
									<span>{t('AddOnePermission.label')}</span>
									<span className="cursor"><AiOutlineClose onClick={() => setPermsValidated(false)} /></span>
								</div>
							}
							<div className="card">
								<Table>
									<thead>
										<tr>
											<th>{t('SectionOrQuestions.label')}</th>
											<th>{t('Users.label')}</th>
										</tr>
									</thead>
									<tbody>{renderTopics()}</tbody>
								</Table>
							</div>
						</div>
						<div className="col-md-5 p-2 text-start">
							{(selectedTopic?.id > 0 || selectedQuestion?.id > 0) && renderPermissionModalQual()}
						</div>
						{renderFooterActions()}
					</div>
				</div>
			</div>
		);
	};

	const renderPermissionModalQual = () => {
		return (
			<div className="AllSection_Viewcard card ">
				<div className="Form_Section_groups">
					<div className="Form_Section_groups_head d-flex justify-content-between">
						<span>{t('Users.label')}</span>
						<span className="cursor" onClick={() => {
							setSelectedTopic(null);
							setSelectedQuestion(null);
						}}><AiOutlineClose /></span>
					</div>
					<div className="Form_Section_groups_body 3">
						<ul>
							{users?.map(user => {
								return (
									<div className="d-flex align-items-baseline" key={`userCheck-${user.id}`}>
										<li key={`group-${user.id}`} className='w-50'>
											<div className="form-check">
												<input className="form-check-input" type="checkbox"
													id={`group-input-${user.id}`}
													checked={isPermittedForUser(user.id)}
													onChange={() => onUserCheck(user.id, user.name)} />
												<label className="form-check-label" htmlFor={`group-input-${user.id}`}>
													<span>{Utils.getTextBasedProfilePic(user.name)}</span> {user.name}
												</label>
											</div>
										</li>
									</div>
								);
							})}
						</ul>
					</div>
				</div>
			</div>
		);
	};

	const confirmationCardToRender = () => {
		return (
			<div className={`assessmentForm_Confirmation ${activeCard === CardType.CONFIRMATION ? '' : 'd-none'}`}>
				<div>
					<h4>{t('ConfirmationCardHeader.label')}</h4>
				</div>
				<div className="assessmentCard_form">
					<div className="row m-0">
						<div className="col-md-9 p-2 text-start Permissions_ConfirmationBox">
							<div>
								<div className="mb-1">{t('Permissions.label')}</div>
								<div className="card">
									<Table className="mb-0">
										<thead>
											<tr>
												<th>{t('SectionOrQuestions.label')}</th>
												<th>{t('Users.label')}</th>
											</tr>
										</thead>
										<tbody>
											{dataToSave.permissions?.map((permission, index) => (
												<tr>
													{permission?.topic ? <td> {permission?.topic?.name}</td> : <td> {permission?.question?.name}</td>}
													<td>
														{permission?.users?.map((user, idx) => (
															<span key={user.id}>
																{user.name}
																{idx < permission.users.length - 1 && ", "}
															</span>
														))}
													</td>
												</tr>
											))}
										</tbody>
									</Table>
								</div>
							</div>
						</div>
						<div className="col-md-3 p-2 text-start">
							<div className="mb-3">
								<span>{t('ReportingPeriod.label')}</span>
								<div>
									<b>{Utils.reportingPeriodToReadableText(dataToSave.period, dataToSave.regulation?.frequency, t)}</b>
								</div>
							</div>
							<div>
								<span>{t('Expiry.label')}</span>
								<div>
									<b>{moment(dataToSave.lastSubmissionDate).format("MMM DD, YYYY")}</b>
								</div>
							</div>
						</div>
					</div>
					<div className="text-center p-3">
						<Button variant="secondary " className="px-4 me-2"
							onClick={() => onBack()}>
							{t("Back.label")}
						</Button>
						<Button variant="secondary " className="px-4 me-2"
							onClick={() => exitModal()}>
							{t("Cancel.label")}
						</Button>
						<Button variant="primary " className="px-4"
							onClick={() => saveQualitativeDCE()} >
							{t("Confirm.label")}
						</Button>
					</div>
				</div>
			</div >
		);
	};

	const wizardToRender = () => {
		return (
			<div className="wizard_lineBox">
				{
					<ul>

						<li className={getWizardBubbleClass(CardType.FORM_DETAILS)}><span></span></li>
						<li className={getWizardBubbleClass(CardType.PERMISSION_CONFIGURATION)}><span></span></li>
						<li className={getWizardBubbleClass(CardType.CONFIRMATION)}><span></span></li>
					</ul>
				}
			</div>
		);
	};

	const getWizardBubbleClass = (cardType) => {
		return activeCard > cardType
			? 'done'
			: (activeCard === cardType ? 'select' : '');
	};

	const renderSelectedUserForTopic = (topicId) => {
		return (
			<div className="Group_id_Box">
				{
					dataToSave.permissions?.find(p => p?.topic?.id === topicId)?.users?.map(user => {
						return (
							<span>
								{Utils.getTextBasedProfilePic(users?.find(u => u.id === user.id)?.name)}
							</span>
						);
					})
				}
			</div>
		)
	}

	const renderSelectedUserForQuestion = (qId) => {
		return (
			<div className="Group_id_Box">
				{
					dataToSave.permissions?.find(p => p?.question?.id === qId)?.users?.map(user => {
						return (
							<span>
								{Utils.getTextBasedProfilePic(users?.find(u => u.id === user.id)?.name)}
							</span>
						);
					})
				}
			</div>
		)
	}

	return (
		<>
			<Modal
				show={show}
				onHide={() => exitModal()}
				size="xl"
				aria-labelledby="contained-modal-title-vcenter"
				centered >
				<Modal.Header closeButton>
					<Modal.Title as="h5">

					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="assessment_modal_card">
						<div className="">
							{(!enablePermCard) && wizardToRender()}
							{detailsCardToRender()}
							{permissionConfigurationCardToRender()}
							{confirmationCardToRender()}
						</div>
					</div>
				</Modal.Body>
			</Modal>

		</>
	);
}

export default withTranslation()(QualitativeDCEModal);
